import { FC } from 'react';

import { Button, Modal } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import HtmlContent from '@telialt/common-html-content/src';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';

import { Z_INDEX_MODAL } from '../../../../constants/constants';
import { useVasRatePlanModalControls } from './useVasRatePlanModalControls';

export const VasRatePlanModal: FC = () => {
    const { t } = useTranslations();
    const { isModalOpen, modalData, closeModal } = useVasRatePlanModalControls();

    const buttons = [
        <Button key="close-modal" variant="primary" onClick={closeModal} data-test={ESHOP_TEST_ID.MODAL_CLOSE_BTN}>
            {t['common.button.close']}
        </Button>,
    ];

    return (
        <Modal open={isModalOpen} onOpenChange={(open) => !open && closeModal()}>
            <Modal.Content
                title={modalData?.title}
                actions={buttons}
                stickyButtons={true}
                closeButtonAriaLabel={t['common.button.close']}
                showCloseButton={true}
                data-test={ESHOP_TEST_ID.RATE_PLAN_VAS_MODAL}
                zIndex={Z_INDEX_MODAL}
            >
                <HtmlContent content={modalData?.content} />
            </Modal.Content>
        </Modal>
    );
};
